module.exports = __webpack_public_path__ + "img/20.0a8d9cee.svg";